import CarrierEditModal from './styled';

export default CarrierEditModal;
